@if (sidebarMode()) {
  <button
    class="sidebar-toggle btn btn-secondary"
    type="button"
    (click)="toggle()"
    [attr.aria-expanded]="open() ? 'true' : 'false'"
    aria-controls="app-sidebar"
    aria-label="Mostrar menú principal"
  >
    Menú
  </button>

  <button
    class="sidebar-backdrop"
    type="button"
    [class.sidebar-backdrop--open]="open()"
    [attr.aria-hidden]="open() ? 'false' : 'true'"
    aria-label="Cerrar menú de navegación"
    (click)="closeMenu()"
    tabindex="-1"
  ></button>

  <aside class="app-sidebar" id="app-sidebar" [class.app-sidebar--open]="open()">
    <div class="sidebar-panel">
      <div class="sidebar-brand-block">
        <a class="brand brand--sidebar" routerLink="/dashboard/kyc" (click)="closeMenu()"
          >PanaKYC</a
        >
        <p class="sidebar-kicker">Workspace de organización</p>
        <p class="sidebar-copy">
          Acceda a cuestionarios, métricas KYC y la administración de usuarios de su organización.
        </p>
      </div>

      <nav class="sidebar-nav" role="navigation" aria-label="Main navigation">
        <ul class="sidebar-links">
          @for (link of links(); track link.path) {
            <li
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: link.exact ?? false }"
            >
              <a
                [routerLink]="link.path"
                (click)="closeMenu()"
                [attr.aria-current]="isCurrentPage(link) ? 'page' : null"
              >
                <span class="nav-icon" aria-hidden="true">{{ link.icon }}</span>
                <span>{{ link.label }}</span>
              </a>
            </li>
          }
        </ul>
      </nav>

      <div class="sidebar-account">
        <p class="sidebar-label">Sesión actual</p>
        <p class="sidebar-email">{{ currentUser()?.email ?? 'Sin sesión activa' }}</p>
        <button class="btn btn-secondary signout" type="button" (click)="logout()">Salir</button>
      </div>
    </div>
  </aside>
} @else {
  <nav class="site-nav" role="navigation" aria-label="Main navigation">
    <div class="nav-inner container">
      <a class="brand" routerLink="/">PanaKYC</a>

      <div class="public-actions">
        <ul class="nav-links">
          @for (link of publicLinks; track link.path) {
            <li
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: link.exact ?? false }"
            >
              <a [routerLink]="link.path">{{ link.label }}</a>
            </li>
          }
        </ul>

        @if (!isAuthenticated()) {
          <a class="btn btn-secondary" routerLink="/login">Iniciar sesión</a>
        } @else if (canAccessOrganizationApp()) {
          <a class="btn btn-primary" routerLink="/dashboard/kyc">Abrir panel</a>
        } @else {
          <button class="btn btn-secondary signout" type="button" (click)="logout()">Salir</button>
        }
      </div>
    </div>
  </nav>
}
